import TicketCuticleDot from '@/components/manage/TicketCuticleDot';
import TicketCuticleLine from '@/components/manage/TicketCuticleLine';
import { cn } from '@/utils/cn';

interface TicketCuticleProps {
  isVertical?: boolean;
  className?: {
    root?: string;
    dot?: string;
    dotStart?: string;
    dotEnd?: string;
    line?: string;
  };
  dashLength?: number;
  dashColor?: string;
}

const TicketCuticle = ({
  isVertical = true,
  className,
  dashLength,
  dashColor,
}: TicketCuticleProps) => {
  return (
    <div
      className={cn(
        'flex items-center',
        isVertical ? 'h-full w-6 flex-col' : 'h-6 w-full flex-row',
        className?.root
      )}
    >
      <TicketCuticleDot
        isVertical={isVertical}
        position="start"
        className={cn(
          isVertical ? 'mb-0.5' : 'mr-0.5',
          className?.dot,
          className?.dotStart
        )}
      />
      <TicketCuticleLine
        isVertical={isVertical}
        className={className?.line}
        dashLength={dashLength}
        dashColor={dashColor}
      />
      <TicketCuticleDot
        isVertical={isVertical}
        position="end"
        className={cn(
          isVertical ? 'mt-0.5' : 'ml-0.5',
          className?.dot,
          className?.dotEnd
        )}
      />
    </div>
  );
};

export default TicketCuticle;
